import { useEffect, useState, RefObject } from 'react';

// Specify that the hook accepts a RefObject of type HTMLElement
const useIntersectionObserver = (
  elementRef: RefObject<HTMLElement>
): boolean => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Ensure the element is current before observing
    if (!elementRef.current) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setIsVisible(entry.isIntersecting);
    });

    observer.observe(elementRef.current);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, [elementRef]);

  return isVisible;
};

export default useIntersectionObserver;
